module.exports = __webpack_public_path__ + "media/flags/eg-98d46460.svg";